import React, { useContext } from "react";
import styles from "./index.module.scss";
import Topic from "./Components/Topic";
import AnswerEditor from "./Components/AnswerEditor";
import { BackTop } from "antd";
import AnswerList from "./Components/AnswerList";
import { RouteComponentProps } from "react-router-dom";
import { DiscussContent } from "./context";
import { AskTeacherProvider } from "./provider";
import { TopicType } from "../../../service/discuss";

type AskTeacherDetailProps = RouteComponentProps<{
    uuid: string;
    courseNo: string;
    courseSeq: string;
    batchNo: string;
}>;

export function AskTeacherDetailInner() {
    const { isWriting } = useContext(DiscussContent);

    return (
        <div className={styles.root}>
            <Topic isFollow={false} />

            {isWriting && <AnswerEditor />}

            <AnswerList />

            <BackTop />
        </div>
    );
}

export default function AskTeacherDetail({ match }: AskTeacherDetailProps) {
    const params = match.params;

    return (
        <AskTeacherProvider {...params} topicType={TopicType.Ask}>
            <div className={styles.root}>
                <AskTeacherDetailInner />
            </div>
        </AskTeacherProvider>
    );
}
